import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import BodmasEditQuestionsTable from './EditQuestion';
const BodmasEditQuestions = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Edit Questions' parent='Edit Questions'  />
      <Container fluid={true}>
        <Row>
          <BodmasEditQuestionsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default BodmasEditQuestions;
